import * as ROUTES from '@/router/route-names'

export default [
  {
    path: '/admin/admin-dashboard',
    name: ROUTES.ADMIN_DASHBOARD,
    component: () => import('../views/admin/AdminDashboard.vue'),
  },
  {
    path: '/admin/prospects',
    name: ROUTES.ADMIN_PROSPECTS,
    component: () => import('../views/Prospects.vue'),
  },
  {
    path: '/admin/accounts',
    name: ROUTES.ADMIN_ACCOUNTS,
    component: () => import('../views/admin/AdminAccounts.vue'),
  },
  {
    path: '/admin/accounts/:accountCode/users',
    name: ROUTES.ADMIN_ACCOUNT_USERS,
    component: () => import('../views/admin/AdminAccountUsers.vue'),
  },
  {
    path: '/admin/users',
    name: ROUTES.ADMIN_USERS,
    component: () => import('../views/admin/AdminUsers.vue'),
  },
  {
    path: '/admin/users/:username',
    name: ROUTES.ADMIN_USER_DETAILS,
    component: () => import('../views/admin/AdminUserDetails.vue'),
  },
  {
    path: '/admin/brokerages',
    name: ROUTES.ADMIN_BROKERAGES,
    component: () => import('../views/admin/AdminBrokerages.vue'),
  },
  {
    path: '/admin/account-brokerage-manager',
    name: ROUTES.ADMIN_BROKERAGE_MGR,
    component: () => import('../views/admin/AdminAccountBrokerageManager.vue'),
  },
  {
    path: '/admin/bulk-account-upload',
    name: ROUTES.ADMIN_BULK_ACCOUNT_UPLOAD,
    component: () => import('../views/admin/BulkAccountUpload.vue'),
  },
  {
    path: '/admin/brokerages/:brokerCode',
    name: ROUTES.ADMIN_BROKERAGE_DETAIL,
    component: () => import('../views/admin/AdminBrokerageDetail.vue'),
  },
  {
    path: '/admin/brokerages/:brokerCode/billing',
    name: ROUTES.ADMIN_BROKERAGE_BILLING,
    component: () => import('../views/admin/BrokerageBillingPlan.vue'),
  },
  {
    path: '/admin/delete-account',
    name: ROUTES.ADMIN_DELETE_ACCOUNT,
    component: () => import('../views/admin/AdminDeleteAccount.vue'),
  },
  {
    path: '/admin/api-users',
    name: ROUTES.ADMIN_API_USERS,
    component: () => import('../views/admin/AdminApiUsers.vue'),
  },
  {
    path: '/admin/errors',
    name: ROUTES.ADMIN_ERRORS,
    component: () => import('../views/admin/AdminErrors.vue'),
  },
  {
    path: '/admin/wizard-documents',
    name: ROUTES.ADMIN_WIZARD_FILES,
    component: () => import('../views/admin/WizardRecentDocuments.vue'),
  },
  {
    path: '/admin/schedules',
    name: ROUTES.ADMIN_SCHEDULES,
    component: () => import('../views/admin/scheduler/AdminSchedulesView'),
  },
  {
    path: '/admin/rules-and-targets',
    name: ROUTES.ADMIN_SCHEDULE_RULES,
    component: () => import('../views/admin/scheduler/AdminSchedulerView'),
  },
  {
    path: '/admin/recent-events',
    name: ROUTES.ADMIN_RECENT_EVENTS,
    component: () => import('../views/admin/scheduler/AdminRecentEventsView'),
  },
  {
    path: '/admin/app-library',
    name: ROUTES.ADMIN_DOC_LIBRARY,
    component: () => import('../views/admin/AdminDocLibrary'),
  },
  {
    path: '/admin/broadcast',
    name: ROUTES.ADMIN_BROADCAST,
    component: () => import('../views/admin/AdminBroadcast'),
  },
  {
    path: '/admin/pdf/editor',
    name: ROUTES.PDF_EDITOR,
    component: () => import('../views/pdfeditor/PdfFieldEditorView.vue'),
  },
  {
    path: '/admin/pdf/copy-fields',
    name: ROUTES.PDF_FIELDS_COPY,
    component: () => import('../views/pdfeditor/PdfFieldsCopyView.vue'),
  },
  {
    path: '/admin/test-email',
    name: ROUTES.ADMIN_TEST_EMAIL,
    component: () => import('../views/admin/AdminTestEmail.vue'),
  },
  {
    path: '/admin/feature-flag-report',
    name: ROUTES.ADMIN_FEATURE_FLAG_REPORT,
    component: () => import('../views/admin/AdminFeatureFlagReport.vue'),
  },
  {
    path: '/admin/schedule-imports',
    name: ROUTES.ADMIN_SCHEDULE_IMPORTS,
    component: () => import('../views/admin/AdminScheduleImports.vue'),
  },
  {
    path: '/admin/alps-onboarding',
    name: ROUTES.ADMIN_SCHEDULE_IMPORTS,
    component: () => import('../views/admin/alps/AlpsMassInvite.vue'),
  },
]
